// @ts-nocheck
import axios from 'axios';

import API_ENDPOINTS from '../../../const/ApiEndPoints';

/**
 * This API will fetch the constant attributes
 *
 * @param {string} minimal - pass as true
 * @returns {object} - {id, name, display_name, description, data_type} reponse with minimal data
 */
export const getAllConstantAttributesList = (params, loader = true) => {
  return axios
    .get(
      `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CNF.CA.GET_ALL_CONSTANT_ATTRIBUTES}`,
      { params, loader }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export default function useConstantAttributes() {
  const getConstantAttributeSchema = (params) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CNF.CA.GET_SCHEMA}`,
        { params }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const getConstantAttributeSchemaPaginated = (params) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CNF.CA.GET_SCHEMA}`,
        { params: { ...params, page_size: 100 }, loader: false }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const deleteConstantAttribute = (attributeId) => {
    return axios
      .delete(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CNF.CA.DELETE_CONSTANT_ATTRIBUTE}`,
        { params: { constant_id: attributeId } }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const createConstantAttribute = (payload) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CNF.CA.CREATE_CONSTANT_ATTRIBUTE}`,
        payload
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const getSingleConstantAttributeDetails = (attributeId) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CNF.CA.GET_SINGLE_CONSTANT_ATTRIBUTE}`,
        { params: { constant_id: attributeId } }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const updateConstantAttribute = (payload) => {
    return axios
      .put(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CNF.CA.UPDATE_CONSTANT_ATTRIBUTE}`,
        payload
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const updateConstantAttributeExcelSchema = (payload) => {
    return axios
      .put(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CNF.CA.EDIT_EXCEL_SCHEMA}`,
        payload
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const getExcelProcessingStatus = (uploadId) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CNF.CA.PROGRESS_STATUS}`,
        { params: { upload_id: uploadId }, loader: false }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const getConstantAttributeVersions = (constantId) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CNF.CA.GET_VERSIONS}`,
        { params: { constant_id: constantId } }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const rollbackConstantAttributeVersion = (payload) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.CNF.CA.ROLLBACK_VERSION}`,
        payload
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  return {
    getAllConstantAttributesList,
    deleteConstantAttribute,
    createConstantAttribute,
    getSingleConstantAttributeDetails,
    updateConstantAttribute,
    getConstantAttributeSchema,
    getConstantAttributeSchemaPaginated,
    updateConstantAttributeExcelSchema,
    getExcelProcessingStatus,
    getConstantAttributeVersions,
    rollbackConstantAttributeVersion,
  };
}
